export default {
  owned: 'owned',

  gem_prestigeStone: {
    name: 'Prestige stone',
    description: 'Get prestige currency equal to your best cycle'
  },
  mining_goldenHammer: {
    name: 'Golden hammer',
    description: 'Get the best pickaxe possible for this craft'
  },
  village_ingredientBox: {
    name: 'Ingredient box',
    description: 'Contains special ingredients that can only be found in these boxes'
  },
  horde_manaPotion: {
    name: 'Mana potion',
    description: 'Refill 50% of your maximum mana'
  },
  farm_basic: {
    name: 'Basic fertilizer',
    description: ''
  },
  farm_flower: {
    name: 'Flower fertilizer',
    description: ''
  },
  farm_speedGrow: {
    name: 'Speed-grow',
    description: ''
  },
  farm_richSoil: {
    name: 'Rich soil',
    description: ''
  },
  farm_shiny: {
    name: 'Shiny fertilizer',
    description: ''
  },
  farm_juicy: {
    name: 'Juicy fertilizer',
    description: ''
  },
  farm_dissolving: {
    name: 'Crop dissolver',
    description: ''
  },
  farm_potatoWater: {
    name: 'Potato water',
    description: ''
  },
  farm_roseWater: {
    name: 'Rose water',
    description: ''
  },
  farm_weedKiller: {
    name: 'Weed killer',
    description: ''
  },
  farm_turboGrow: {
    name: 'Turbo-grow',
    description: ''
  },
  farm_premium: {
    name: 'Premium fertilizer',
    description: ''
  },
  farm_analyzing: {
    name: 'Analyzing fertilizer',
    description: ''
  },
  farm_superJuicy: {
    name: 'Super-juicy',
    description: ''
  },
  farm_pellets: {
    name: 'Pellets',
    description: ''
  },
  farm_sunshine: {
    name: 'Sunshine',
    description: ''
  },
  farm_superFlower: {
    name: 'Super flower',
    description: ''
  },
  farm_smellyMud: {
    name: 'Smelly mud',
    description: ''
  },
  farm_tropicalWater: {
    name: 'Tropical water',
    description: ''
  },
  farm_fieldBlessing: {
    name: 'Field blessing',
    description: ''
  },
  farm_cinnamonBag: {
    name: 'Cinnamon bag',
    description: ''
  },
};
